module.exports = __webpack_public_path__ + "img/02.bd05f24d.png";